import React from 'react';
import { Icon } from '@chakra-ui/react';

export const IconSearch = (props) => (
  <Icon viewBox="0 0 28 28" {...props} fill="none">
    <path
      d="M11.4438 21.8877C17.2118 21.8877 21.8876 17.2118 21.8876 11.4438C21.8876 5.67587 17.2118 1 11.4438 1C5.67585 1 1 5.67587 1 11.4438C1 17.2118 5.67585 21.8877 11.4438 21.8877Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M20.7646 20.7647L28.9999 29"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);
